/**
 * 统一缓存管理器（Web 应用版本）
 * 提供统一的缓存接口和管理功能
 */

export interface CachedData<T> {
  data: T;
  timestamp: number;
}

/**
 * 获取缓存（即使过期也返回）
 */
export async function getCache<T>(key: string): Promise<CachedData<T> | null> {
  try {
    const cachedStr = localStorage.getItem(`cache_${key}`);
    if (!cachedStr) {
      return null;
    }
    const cached = JSON.parse(cachedStr) as CachedData<T>;
    return cached;
  } catch (error) {
    console.warn(`[CacheManager] 读取缓存失败 [${key}]:`, error);
    return null;
  }
}

/**
 * 设置缓存
 */
export async function setCache<T>(key: string, data: T): Promise<void> {
  try {
    const cached: CachedData<T> = {
      data,
      timestamp: Date.now(),
    };
    localStorage.setItem(`cache_${key}`, JSON.stringify(cached));
  } catch (error) {
    console.warn(`[CacheManager] 设置缓存失败 [${key}]:`, error);
  }
}

/**
 * 清除缓存
 */
export async function removeCache(key: string): Promise<void> {
  try {
    localStorage.removeItem(`cache_${key}`);
  } catch (error) {
    console.warn(`[CacheManager] 清除缓存失败 [${key}]:`, error);
  }
}

/**
 * 清除所有缓存
 */
export async function clearAllCache(): Promise<void> {
  try {
    const keys = Object.keys(localStorage);
    for (const key of keys) {
      if (key.startsWith('cache_')) {
        localStorage.removeItem(key);
      }
    }
  } catch (error) {
    console.warn('[CacheManager] 清除所有缓存失败:', error);
  }
}
